// Frans (fr-FR), kioskWeather: zelfde vorm als kioskWeather.nl.ts. Zelfde woorden als in
// weatherPrayer.fr.ts; nooit een woord over gebed.
export const kioskWeatherFr = {
    title: 'Météo',
    open: 'Météo : {feel}. Touche pour en savoir plus.',
    stale: 'Météo inconnue pour l’instant',
    today: 'Aujourd’hui',
    tomorrow: 'Demain',
    close: 'Fermer',
    feel: { cold: 'froid', chilly: 'frais', mild: 'doux', warm: 'chaud', hot: 'très chaud' },
    itemLabels: {
        thick_coat: 'Gros manteau',
        coat: 'Manteau',
        sweater: 'Gilet ou pull',
        raincoat: 'Imperméable',
        boots: 'Bottes',
        hat_gloves: 'Bonnet et gants',
        umbrella: 'Parapluie',
        sunscreen: 'Crème solaire',
        sun_hat: 'Casquette',
        water_bottle: 'Gourde',
        shorts: 'Short',
    },
    day: {
        today: 'Voici aujourd’hui',
        tomorrow: 'Voici demain',
        temp: 'Il fait combien ?',
        tempValue: 'De {min} à {max} degrés',
        feels: 'Il fait {feel}',
        rain: 'Pluie',
        rainWords: {
            dry: 'Il ne pleut pas',
            small: 'Peut-être une petite averse',
            likely: 'Il peut pleuvoir',
            wet: 'Il va pleuvoir',
        },
        rainWhen: 'De {from} à {until}',
        wind: 'Vent',
        windWords: {
            calm: 'Presque pas de vent',
            light: 'Un peu de vent',
            fresh: 'Pas mal de vent',
            strong: 'Vent fort',
            very_strong: 'Vent très fort',
        },
        windForce: 'Force {bft}',
        sun: 'Soleil',
        sunrise: 'Se lève à {time}',
        sunset: 'Se couche à {time}',
        uvWords: {
            moderate: 'Le soleil tape. Longtemps dehors ? Alors de la crème.',
            high: 'Le soleil tape très fort. De la crème et une casquette.',
        },
        course: 'Comment se passe la journée ?',
        back: 'Retour',
        now: 'Maintenant',
    },
};
//# sourceMappingURL=kioskWeather.fr.js.map